import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { SeedFlaskPage } from "@/features/fermentation-journal/components/setup";

export const Route = createFileRoute(
  "/fermentations/$group_id/setup/seed-flask",
)({
  component: SeedFlaskRoute,
});

function SeedFlaskRoute() {
  const { group_id } = Route.useParams();
  return (
    <div className="max-w-4xl">
      <SeedFlaskPage groupId={group_id as unknown as FermentationGroupId} />
    </div>
  );
}
